import React from 'react';


function  AtividadesRecentes() {
    return (
        <p>Atividades Recentes</p>
    );
}
export default AtividadesRecentes;